import { ActionStatus } from '../../types'

export function computeStylePermission(isToday: boolean): ActionStatus {
  if (!isToday) return 'disabled'

  return 'enabled'
}
